<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">Notice</h5>
        <div class="component-section">
          <span class="cause" :key="cause" v-for="cause in causes">
            <right-svg class="cause-icon" /> {{ causeMessage[cause] }}
          </span>
        </div>
        <p class="component-paragraph">
          We will clear the selected module, you can keep exploring with the
          selected filters and values to see the systems that fit in, or to
          change the selected filters and values.
        </p>

        <div class="component-button">
          <input
            type="button"
            class="btn btn-secondary"
            value="continue"
            @click="clickedContinue"
          />
        </div>
        <div class="component-button pt-3">
          <input
            v-focus
            type="button"
            class="btn btn-outline-secondary"
            value="undo"
            @click="clickedUndo"
          />
        </div>
        <div class="component-button pt-3">
          <input
            v-if="causes.includes('NO_VALID_SYSTEM')"
            type="button"
            class="btn btn-outline-secondary"
            value="remove driver"
            @click="clickedRemoveDriver"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { CAUSES } from "@/service/Constants";
import rightSvg from "@/assets/svg/icons/signify-icons_09-right-12px.svg?inline";

export default {
  name: "ValidateErrorModal",
  data() {
    return {
      show: true,
      causeMessage: CAUSES
    };
  },
  components: {
    rightSvg
  },
  props: {
    causes: {
      type: Array,
      required: true
    },
    onContinue: {
      type: Function,
      required: false,
      default: () => {}
    },
    onUndo: {
      type: Function,
      required: false,
      default: () => {}
    },
    onRemoveDriver: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  methods: {
    clickedContinue() {
      this.show = false;
      this.onContinue();
    },
    clickedUndo() {
      this.show = false;
      this.onUndo();
    },
    clickedRemoveDriver() {
      this.show = false;
      this.onRemoveDriver();
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph,
  .component-section {
    font-size: 16px;
    margin: 0 0 30px 0;
  }
  .form-control {
    margin: 0 0 30px 0;
  }

  .cause {
    font-size: 16px;
    display: block;

    .cause-icon {
      width: 16px;

      path {
        fill: $blue-500;
      }
    }
  }

  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
